var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',{staticClass:"fill-height background"},[_c('router-view')],1),_c('notifications',{attrs:{"group":"notification","position":"bottom center","width":"300"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }